import { render, staticRenderFns } from "./RedCircle.vue?vue&type=template&id=81649a36"
import script from "./RedCircle.vue?vue&type=script&lang=js"
export * from "./RedCircle.vue?vue&type=script&lang=js"
import style0 from "./RedCircle.vue?vue&type=style&index=0&id=81649a36&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports